import React from "react";
import { LoadioConfigurationTemplate } from "themes/administration/loadio/pages";
import { LoadioConfigurationViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";
import { observer } from "mobx-react";

@setCurrentView(
    (rootStore, componentProps) => new LoadioConfigurationViewStore(rootStore, componentProps),
    "loadioConfigurationViewStore"
)
@observer
class LoadioConfiguration extends React.Component {
    render() {
        return <LoadioConfigurationTemplate {...this.props} />;
    }
}

export default LoadioConfiguration;
